import { Skeleton } from "../ui/skeleton";

export const SkeletonCard = () => {
	return (
		<div className="bg-white rounded-lg shadow-md overflow-hidden">
			<Skeleton className="h-48 w-full" />

			<div className="p-4 space-y-3">
				<Skeleton className="h-4 w-3/4" />

				<Skeleton className="h-6 w-full" />

				<div className="flex items-center space-x-2">
					<Skeleton className="h-3 w-3 rounded-full" />
					<Skeleton className="h-3 w-1/2" />
				</div>

				<div className="flex justify-between">
					<Skeleton className="h-3 w-1/4" />
					<Skeleton className="h-3 w-1/4" />
				</div>

				<div className="space-y-2">
					<Skeleton className="h-4 w-1/3" />
					<Skeleton className="h-5 w-1/2" />
				</div>

				<div className="flex justify-between pt-3">
					<Skeleton className="h-8 w-1/3" />
					<Skeleton className="h-8 w-1/4" />
				</div>
			</div>
		</div>
	);
};
